module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "topline"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-wrapper"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/home'
      }
    }
  }, [_vm._v("Kezdőlap")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/palyazatok'
      }
    }
  }, [_vm._v("Pályázatok")])], 1), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (_vm.$root.tmpLoginOpen) ? _c('div', {
    staticClass: "popup",
    staticStyle: {
      "width": "400px",
      "position": "absolute"
    }
  }, [_c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.$root.closeTmpLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h1', [_vm._v("Bejelentkezés")]), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "tmp_login_email",
      "label": "Email cím",
      "errors": _vm.tmp_login_errors,
      "name": "tmp_login_email"
    },
    on: {
      "onkeydownEnter": _vm.tmpLogin
    },
    model: {
      value: (_vm.tmp_login_email),
      callback: function($$v) {
        _vm.tmp_login_email = $$v
      },
      expression: "tmp_login_email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "button v2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tmpLogin
    }
  }, [_vm._v("Bejelentkezés")])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "logo-and-copyright"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("\n                  KTR\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                  Kiválósági és Támogatási Rendszer\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('span', [_vm._v("© 2018 Uninet Kft.")]), _vm._v(" Minden jog fenntarva.\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/admin",
      "target": "_blank"
    }
  }, [_vm._v("Admin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "photo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df06cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tpl_footer.vue
// module id = 337
// module chunks = 0